import { render, staticRenderFns } from "./CustomWizardStep.vue?vue&type=template&id=c4404e4e&"
import script from "./CustomWizardStep.vue?vue&type=script&lang=js&"
export * from "./CustomWizardStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports